export default function () {
  return [
    {
      title: 'Strona główna',
      to: '/kokpit',
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: '',
      permissions: 'dashboard'
    },
    {
      title: 'Zamówienia',
      to: '/zamowienia',
      htmlBefore: '<i class="material-icons">shopping_basket</i>',
      htmlAfter: '',
      permissions: 'orders'
    },
    {
      title: 'Produkty',
      to: '/produkty',
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      htmlAfter: '',
      permissions: 'products'
    },
    {
      title: 'Klienci',
      to: '/klienci',
      htmlBefore: '<i class="material-icons">assignment_ind</i>',
      htmlAfter: '',
      permissions: 'customers'
    },
    {
      title: 'Użytkownicy',
      to: '/uzytkownicy',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: '',
      permissions: 'users'
    },
    {
      title: 'Kalendarz',
      to: '/kalendarz',
      htmlBefore: '<i class="material-icons">calendar_today</i>',
      htmlAfter: '',
      permissions: 'calendar'
    },
    {
      title: 'Cele',
      to: '/cele',
      htmlBefore: '<i class="material-icons">verified</i>',
      htmlAfter: '',
      permissions: 'users'
    },
    {
      title: 'Wyloguj się',
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      permissions: false,
      to: '/wyloguj'
    }
  ];
}
